'use client';

import Link from '@eliadmin/core/src/components/link';
import { fetchProjectBlogs as fetchBlogs } from '../../api/project-listings';
import { CarouselProvider } from '@eliadmin/core/src/components/ui/carousel-context';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../shared/heading';
import { CarouselControls } from '@eliadmin/core/src/components/ui/carousel-controls';
import { Carousel } from '../ui/carousel';
import { BlogCard } from '../blog/blog-card';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useQuery } from '@tanstack/react-query';
import { CacheKey } from '@eliadmin/core/src/api/constants';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function TourBlogs({ locale }: { locale: string }) {
  const { t } = useTranslations();
  const { data: blogs = { data: [] } } = useQuery({
    queryKey: [CacheKey.BLOGS, locale],
    queryFn: () =>
      fetchBlogs({
        locale,
        query: {
          sort: '-createdAt',
          page: 1,
          results: 8,
          where: { categories: { equals: 8 } },
        },
      }),
  });

  return (
    <CarouselProvider>
      <div
        className={cn(
          'custom-container',
          'mt-16 flex flex-col items-center justify-center gap-12 lg:mt-24',
        )}
      >
        <div className="flex w-full items-center justify-start gap-6 lg:justify-between">
          <Heading title={t('text3977') ?? ''} />
          <CarouselControls
            className={{
              button:
                'flex h-[52px] w-[52px] items-center justify-center rounded-[16px] border-none bg-white text-xl text-primary shadow-none hover:bg-white/90 hover:text-primary',
              main: 'hidden items-center justify-end gap-2 lg:flex',
            }}
          />
        </div>
        <Carousel
          className={{
            container: 'w-full gap-4 sm:gap-6 lg:gap-8',
            wrapper: 'w-full',
            main: 'w-full',
            slide: 'max-w-[405px]',
          }}
          slides={blogs.data.map(blog => (
            <BlogCard blog={blog} key={blog.slug} />
          ))}
        />
        <Button asChild variant={'dark'} className="w-full sm:w-fit">
          <Link prefetch={false} href={'/blog?categoryId=8'}>
            {t('text2000')}
          </Link>
        </Button>
      </div>
    </CarouselProvider>
  );
}
